<template>
  <div
    class="pa-2 img"
    :class="{
      active: value == bot.value,
      primary: value == bot.value,
      islock: bot.isLock
    }"
  >
    <v-tooltip right>
      <template #activator="{ on }">
        <v-avatar v-on="on">
          <img
            class="responsive-img circle"
            style="min-width: 100%"
            alt
            :src="
              'https://graph.facebook.com/' +
              bot.value +
              '/picture?width=100&height=100&SameSite=None'
            "
          />
        </v-avatar>
      </template>
      <span>{{ bot.name }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: ['value', 'bot']
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-avatar.vue